import SignupPage from './pages/Page.vue';

export { SignupPage };